export const GET_BLEMISH_REPORT_REQUEST = 'GET_BLEMISH_REPORT_REQUEST';
export const GET_BLEMISH_REPORT_SUCCESS = 'GET_BLEMISH_REPORT_SUCCESS';
export const GET_BLEMISH_FIELD_SUCCESS = 'GET_BLEMISH_FIELD_SUCCESS';
export const GET_BLEMISH_REPORT_FAILURE = 'GET_BLEMISH_REPORT_FAILURE';



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/redux/constants/questions_constants/get_blemish_report.constants.js